import prefixNamespace from '@/utils/prefix-namespace'
import { storeKeyNameSpace } from '@/constants/stores'

export const _types = {
    getters: {
        GET_PLANS: 'getPlans',
        GET_TRIAL: 'getTrial',
        GET_IMAGE_PLANS: 'getImagePlans'
    },
    actions: {
        GET_PLANS: 'getPlans',
        GET_TRIAL: 'getTrial',
        HANDLE_CHARGE_PLAN: 'handleChargePlan',
        CREATE_DISCOUNT: 'createDiscount',
        CHECK_DISCOUNT: 'checkDiscount',
        GET_IMAGE_PLANS: 'getImagePlans',
        BUY_MORE_IMAGES: 'buyMoreImages',
        UPDATE_PRICING_VERSION: 'updatePricingVersion'
    },
    mutations: {
        SET_PLANS: 'setPlans',
        SET_TRIAL: 'setTrial',
        SET_IMAGES_PLANS: 'setImagePlans'
    }
}

export const types = prefixNamespace(`${storeKeyNameSpace.CHARGE}/`, _types)